import ethereum from 'decentralized/ethereum.js';
import {sleep} from 'utils/sleep.js';

export const getOrMakeGuildWith = (shareWith) => {
    return new Promise(async (resolve) => {
        let {users, guilds} = ethereum;
        let intersected = undefined;
        let toInvite = [... shareWith];

        shareWith.push(await users.getUserName());

        for (let user of shareWith) {
            let userId = await users.getUserId(user);
            let userGuilds = await guilds.getGuildsForUser(userId);
            userGuilds = new Set(userGuilds.map(x => x.guildId));
            if (intersected === undefined) {
                intersected = userGuilds;
            } else {
                intersected = intersect(intersected, userGuilds);
            }
        }
        intersected = Array.from(intersected);
        let guild = undefined;
        if (intersected.length === 0) {
            // need to make a guild for these people
            // i think i need a new guild contract to do this correctly...

            // NEED TO Create the guild WITH the people
            let name = shareWith.join(",");
            let guildKey = await guilds.newGuild(name); 

            while (true) {
                let myGuilds = await guilds.getGuildsForUser();
                console.log("GUILDS found =", myGuilds);
                guild = myGuilds.find(g => g.name === name); 
                if (guild) {
                    guild = guild.guildId;
                    break;
                }
                await sleep(2000);
            }
            guilds.saveGuildKey(guild, guildKey);
            resolve(guild);
            // request to add member
            for (let user of toInvite) {
                let userId = await users.getUserId(user);
                await guilds.requestToAddMember(guild, userId);
            }
            return;
        } else {
            guild = intersected[0];
        }

        resolve(guild);
    });
};

const intersect = (a, b) => {
    let intersected = [];
    for (let x of a) {
        if (b.has(x)) {
            intersected.push(x);
        }
    }

    for (let x of b) {
        if (a.has(x)) {
            intersected.push(x);
        }
    }
    return new Set(intersected);
};
